import { render, staticRenderFns } from "./StaffData.vue?vue&type=template&id=f2aaea74&"
import script from "./StaffData.vue?vue&type=script&lang=js&"
export * from "./StaffData.vue?vue&type=script&lang=js&"
import style0 from "./StaffData.vue?vue&type=style&index=0&lang=css&"
import style1 from "./StaffData.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports